<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="edit-product-dialog"
  >
    <div class="form-content">
      <product-form
        :form-data="formData"
        ref="outform"
        @submit="submit"
      ></product-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import productForm from "@/components/authorize/product/productForm";
import { editProduct } from "@/api/authorize/product";

export default {
  name: "editProductDialog",
  components: {
    productForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default() {
        return {
          id: '',
        }
      }
    }
  },
  data() {
    return {
      title: '编辑产品',
    }
  },
  watch: {
    dialogShow(newValue) {
      if (newValue && this.formData.id) {
        setTimeout(() => {
          this.$refs.outform.assigen(this.formData);
        }, 200);
      }
    },
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        id: form.id,
        productName: form.productName,
        productCode: form.productCode,
        trialPeriod: form.trialPeriod === undefined || form.trialPeriod === '' ? null : Number(form.trialPeriod),
        status: form.status,
      }
      editProduct(params).then((data) => {
        if (data && data.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('edit-success');
        } else {
          this.$message.error(data && data.msg ? data.msg : '编辑失败');
        }
      }).catch(() => {})
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .edit-product-dialog.sidebar-dialog .vs-sidebar {
    width: 600px;
  }
}

</style>
